import "core-js/modules/es.array.map.js";
import "core-js/modules/es.array.filter.js";
import "core-js/modules/es.object.to-string.js";
import "core-js/modules/es.symbol.js";
import "core-js/modules/es.symbol.description.js";
import React from 'react';
import { getProductTypeLabel } from '@finect/front-resources/Products';
import { Section } from '../../Section';
import { Tiles } from '../../Tiles';
import { TipCard } from '../../Products';
var FundGettingStarted = function FundGettingStarted(_ref) {
  var productType = _ref.productType,
    gettingStarted = _ref.gettingStarted,
    _ref$bottomMargin = _ref.bottomMargin,
    bottomMargin = _ref$bottomMargin === void 0 ? false : _ref$bottomMargin;
  return React.createElement(Section, {
    bottomMargin: bottomMargin,
    title: "Consulta nuestra gu\xEDa r\xE1pida de ".concat(getProductTypeLabel(productType, 'plural', 'lowercase')),
    subtitle: "Aprende a invertir en ".concat(getProductTypeLabel(productType, 'plural', 'lowercase'), ".")
  }, React.createElement(Tiles, {
    qty: 4,
    breakpoints: [{
      screen: 'miniPhone',
      items: 1.2
    }, {
      screen: 'phone',
      items: 1.2
    }, {
      screen: 'phablet',
      items: 2.2
    }, {
      screen: 'tablet',
      items: 3.2
    }, {
      screen: 'miniDesktop',
      items: 4
    }, {
      screen: 'desktop',
      items: 4
    }, {
      screen: 'bigScreen',
      items: 4
    }]
  }, gettingStarted(productType).filter(function (content) {
    return content.productType === productType.id;
  }).map(function (content, index) {
    return React.createElement(TipCard, {
      key: index,
      title: content.title,
      description: content.description,
      href: content.href
    });
  })));
};
export { FundGettingStarted };